import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';
import { CONTENT_BY_LICENSE_POPULATE } from '@/modules/license/constants';
import type { IWithContentByLicense } from '@/modules/license/helpers';
import { type CMSApiBase, createCmsUrl } from './base';

export interface PrivacyPolicyApi extends CMSApiBase, IWithContentByLicense {
  title: string;
  titleH1: string;
  lastUpdated: string;
  tableHtml?: string;
}

export const getPrivacyPolicyUrl = (lang: string) =>
  createCmsUrl({
    path: 'privacy-policy',
    queryData: { ...getCMSLocale(lang), populate: CONTENT_BY_LICENSE_POPULATE },
  });

export const fetchPrivacyPolicy = async (lang: string) =>
  fetcherCMS<PrivacyPolicyApi>(getPrivacyPolicyUrl(lang));
